"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var ua_parser_js_1 = __importDefault(require("ua-parser-js"));
// This exists only to provide compatibility for useragent library that's used
// everywhere else.
function parseUserAgent(uaString) {
    var res = (0, ua_parser_js_1["default"])(uaString);
    if (res.os.name === 'Mac OS') {
        res.os.name = 'Mac OS X';
    }
    if ((res.browser.name === 'Chrome' || res.browser.name === 'Firefox') &&
        (res.device.type === 'mobile' || res.device.type === 'tablet')) {
        res.browser.name += ' Mobile';
    }
    return res;
}
exports["default"] = parseUserAgent;
